module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_engl_primaerlogo_neg.88db42dd.png";